import React, { FC } from 'react';
import { Row, Typography } from 'components';
import { Badge } from 'antd';
import styles from './styles.module.scss';
import { ORDER_ITEM_STATUS_MAPPING, ORDER_STATUS_MAPPING, OrderItemStatusType, OrderStatusType } from 'models/Order';

const { Text } = Typography;

type StatusMapType = {
  label: string;
  color: string;
  dotColor: string;
};

export const DEFAULT_STATUS: StatusMapType = {
  label: 'Unknown',
  color: '#f0f0f0',
  dotColor: 'gray',
};

interface IStatusBadge {
  tooltip?: string;
  type: string; // now accepting unknown status types too
}

export const OrderStatusBadge: FC<IStatusBadge> = React.memo((props) => {
  const { type } = props;

  const status = ORDER_STATUS_MAPPING[type as OrderStatusType] ?? DEFAULT_STATUS;

  return (
    <Row
      className={styles.badge}
      style={{ border: 'none', color: status.dotColor, backgroundColor: status.color }}
      align={'middle'}
    >
      <Badge color={status.dotColor} />
      <Text style={{ color: status.dotColor, fontSize: 12, fontWeight: 500 }}>{status.label}</Text>
    </Row>
  );
});
export const OrderItemStatusBadge: FC<IStatusBadge> = React.memo((props) => {
  const { type } = props;

  const status = ORDER_ITEM_STATUS_MAPPING[type as OrderItemStatusType] ?? DEFAULT_STATUS;

  return (
    <Row
      className={styles.badge}
      style={{ border: 'none', color: status.dotColor, backgroundColor: status.color }}
      align={'middle'}
    >
      <Badge color={status.dotColor} />
      <Text style={{ color: status.dotColor, fontSize: 12, fontWeight: 500 }}>{status.label}</Text>
    </Row>
  );
});
